import { SMB_GUIDED_WIZARD_TEXT as TEXT } from '../../../configs/guidedWizardTranslations'
import assistant from '../assets/guidedSetupAssistant.png'
import styles from '../PlanningSmbGuidedWizard.module.scss'

import { PlanningSmbGuidedText as Text, TGuidedTranslationParams } from './PlanningSmbGuidedText'

export const PlanningSmbGuidedStart = ({ params }: { params: TGuidedTranslationParams }) => (
  <div className={styles.start}>
    <img className={styles.assistant} src={assistant} alt="" />
    <div className={styles.introduction}>
      <span className={styles.completed}>
        <span aria-hidden>✓</span>
        <Text
          text={Number(params.planYearCount) < 3 ? TEXT.completedPeriod : TEXT.completed}
          params={params}
        />
      </span>
      <h2 className={styles.startTitle}>
        <Text text={TEXT.startTitle} />
      </h2>
      <p className={styles.startLead}>
        <Text
          text={Number(params.planYearCount) < 3 ? TEXT.startLeadPeriod : TEXT.startLead}
          params={params}
        />
      </p>
      <div className={styles.requirements}>
        <div className={styles.required}>
          <h3 className={styles.requirementTitle}>
            <Text text={TEXT.required} />
          </h3>
          <ul>
            <li>
              <Text text={TEXT.reviewBaseline} params={params} />
            </li>
            <li>
              <Text
                text={Number(params.planYearCount) < 3 ? TEXT.setGrowthPeriod : TEXT.setGrowth}
                params={params}
              />
            </li>
          </ul>
        </div>
        <div className={styles.optionalRequirement}>
          <h3 className={styles.requirementTitle}>
            <Text text={TEXT.optional} />
          </h3>
          <ul>
            <li>
              <Text text={TEXT.optionalLead} />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
)
